import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { ChartBar, Buildings, MagnifyingGlass, Ranking, FileArrowDown, Receipt, Warning } from "@phosphor-icons/react";

const NAV = [
  { to: "/admin", label: "Overview", icon: ChartBar, exact: true, testid: "admin-nav-overview" },
  { to: "/admin/businesses", label: "Businesses", icon: Buildings, testid: "admin-nav-businesses" },
  { to: "/admin/rankings", label: "Rankings", icon: Ranking, testid: "admin-nav-rankings" },
  { to: "/admin/reports", label: "Reports", icon: FileArrowDown, testid: "admin-nav-reports" },
  { to: "/admin/search", label: "Search", icon: MagnifyingGlass, testid: "admin-nav-search" },
  { to: "/admin/distributors", label: "Distributors", icon: Receipt, testid: "admin-nav-distributors" },
];

export default function AdminLayout() {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading && (!user || user.role !== "owner")) {
      nav("/dashboard", { replace: true });
    }
  }, [user, loading, nav]);

  if (loading || !user) {
    return <div className="p-10 font-heading text-xl">Loading admin…</div>;
  }
  if (user.role !== "owner") {
    return (
      <div className="p-10 max-w-xl mx-auto text-center">
        <Warning size={48} weight="bold" className="mx-auto text-[#FF6B6B]" />
        <h1 className="font-heading text-3xl font-black mt-4">Access denied</h1>
        <p className="text-sm text-[#4A4A4A] mt-2">This area is restricted to platform owners.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="admin-shell">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-md border-2 border-black bg-[#111] text-white flex items-center justify-center">
          <ChartBar size={20} weight="bold" />
        </div>
        <div>
          <p className="text-[10px] font-bold tracking-[0.25em] uppercase text-[#4A4A4A]">DueMate · Owner Console</p>
          <h1 className="font-heading text-2xl sm:text-3xl font-black tracking-tighter leading-none">Business Intelligence</h1>
        </div>
      </div>

      <div className="nb-card p-2 flex flex-wrap gap-1" data-testid="admin-subnav">
        {NAV.map(({ to, label, icon: Icon, testid, exact }) => (
          <NavLink
            key={to}
            to={to}
            end={exact}
            data-testid={testid}
            className={({ isActive }) =>
              `flex items-center gap-2 px-3 py-2 rounded-md text-xs font-bold uppercase tracking-wider transition-colors ${
                isActive ? "bg-[#111111] text-white" : "text-[#111] hover:bg-[#F3F0E9]"
              }`
            }
          >
            <Icon size={14} weight="bold" />
            {label}
          </NavLink>
        ))}
      </div>

      <div key={location.pathname} className="anim-fade-up">
        <Outlet />
      </div>
    </div>
  );
}
